import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import {
  getBankAccountLinkingWidgetUrl,
  getBankAccountLinkingWidgetUrlFail,
  getBankAccountLinkingWidgetUrlSuccess,
} from '../reducers/bank-account-linking.reducer';

const getBankAccountLinkingWidgetUrlEpic: RootEpic = (action$, state$, { api }) => {
  return action$.pipe(
    filter(getBankAccountLinkingWidgetUrl.match),
    mergeMap(() =>
      api.bankAccountLinking
        .getAccountLinkingWidgetUrl()
        .then(getBankAccountLinkingWidgetUrlSuccess)
        .catch(getBankAccountLinkingWidgetUrlFail),
    ),
  );
};

export { getBankAccountLinkingWidgetUrlEpic };
